export default {
  data() {
    return {
      halloweenThemeEnabled: window.localStorage.getItem('process-halloween-theme') !== 'off'
    };
  },
  created() {
    window.addEventListener('process-halloween-theme-change', this.onHalloweenThemeChange);
  },
  beforeDestroy() {
    window.removeEventListener('process-halloween-theme-change', this.onHalloweenThemeChange);
  },
  methods: {
    onHalloweenThemeChange(event) {
      this.halloweenThemeEnabled = event.detail;
    }
  }
};
